import type {VoidFunctionComponent} from "react";
import React from "react";
import s from "./SongDetailsLessonsListGroupItem.module.scss";
import {FontIcon} from "../../../../../../components/common/FontIcon";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../../../../../redux/hooks";
import {deviceStore} from "../../../../../../redux/device/deviceStore";

export interface ISongDetailsLessonsListGroupItemProps {
  title: string;
  difficulty: string;
  hasVideo?: boolean;
  isInUserLibrary?: boolean;
  isFavorited?: boolean;
  isActive?: boolean;
  detailsUrl?: string;
}

export const SongDetailsLessonsListGroupItem: VoidFunctionComponent<ISongDetailsLessonsListGroupItemProps> = ({title, difficulty, hasVideo, isInUserLibrary, isFavorited, isActive, detailsUrl}) => {
  const isDeviceTypeMobile = useAppSelector(deviceStore.getDeviceIsMobile);

  const useClassNames = [
    s.lessonGroupItem,
  ];
  if (isActive) {
    useClassNames.push(s.activeItem);
  }

  const indicatorIcon = getIndicatorIcon(isInUserLibrary, isFavorited);
  const navigate = useNavigate();
  const navigateToDetailsUrl = () => {
    if (!detailsUrl) {
      // no url, nothing to do.
      return;
    }

    let options= {};
    if (!isDeviceTypeMobile) {
      options = {replace: true};
    }

    navigate(detailsUrl, options);
  }

  return (
    <li className={useClassNames.join(` `)} onClick={navigateToDetailsUrl}>
      <span className={s.arrangementDifficulty}>{difficulty}</span>
      <span className={s.arrangementTitle}>{title}</span>
      <div className={s.videoStatus}>
        {hasVideo ? <FontIcon icon={"icon-video-tutorial-solid"} /> : null}
      </div>
      <div className={s.libraryStatus}>
        {indicatorIcon}
      </div>
    </li>
  );

  function getIndicatorIcon(isInUserLibrary: boolean | undefined, isFavorited: boolean | undefined) {
    if (isFavorited) {
      return <FontIcon icon={"icon-favorite-solid"} />
    } else if (!isFavorited && isInUserLibrary) {
      return <FontIcon icon={"icon-plus-oval"} />
    } else {
      return null
    }
  }
}
